var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTagIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Shape") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    type: "matrix",
    values: "0 0 0 0 0.827451 0 0 0 0 0.368627 0 0 0 0 0.403922 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "TurnItBlue---Milestone-2",
    stroke: "none",
    strokeWidth: 1,
    fill: "currentColor",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "14.0_Store-Template_07",
    transform: "translate(-970.000000, -240.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(260.000000, 219.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6-Copy-2",
    transform: "translate(15.000000, 15.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "tag-black-shape",
    transform: "translate(639.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(56.000000, 6.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.5119833,10.6271328 L10.0729488,1.20132242 C9.73841327,0.866648171 9.28966865,0.582928746 8.7264375,0.349794239 C8.1630214,0.116613492 7.64820196,0 7.18170175,0 L1.68990909,0 C1.23219419,0 0.836161457,0.167337125 0.5017184,0.501595228 C0.167275343,0.836038285 0.00012317167,1.23207102 0.00012317167,1.68978592 L0.00012317167,7.18157858 C0.00012317167,7.64803255 0.116597949,8.16271328 0.349871172,8.72612938 C0.583144395,9.28954548 0.866910058,9.73375873 1.20144559,10.0595089 L10.6403414,19.5117215 C10.9659992,19.8373792 11.3617545,20.000185 11.8285321,20.000185 C12.2858309,20.000185 12.6866262,19.8373792 13.0298083,19.5117215 L19.5117984,13.0165996 C19.8374561,12.6908032 20.0001232,12.2950941 20.0001232,11.8285939 C20.0001232,11.3709252 19.8374561,10.9704536 19.5119833,10.6271328 Z M5.41927516,5.41919822 C5.0890398,5.74924862 4.69092633,5.9143663 4.22442613,5.9143663 C3.75811087,5.9143663 3.35981245,5.74924862 3.02976205,5.41919822 C2.69971165,5.08910159 2.53473269,4.69098812 2.53473269,4.22453415 C2.53473269,3.75803394 2.69971165,3.35978175 3.02976205,3.02987007 C3.35985869,2.69977343 3.75811087,2.53465575 4.22442613,2.53465575 C4.69092633,2.53465575 5.08917852,2.69977343 5.41927516,3.02987007 C5.74918684,3.35978175 5.91430452,3.75808018 5.91430452,4.22453415 C5.91430452,4.69098812 5.7493718,5.08910159 5.41927516,5.41919822 Z",
    id: "Shape",
    fill: "currentColor",
    fillRule: "nonzero"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTagIcon);
export default __webpack_public_path__ + "static/media/TagIcon.4b0176b6b1c0397666a4fe2d2b94953d.svg";
export { ForwardRef as ReactComponent };